<mat-radio-group class="radio-group">
  <ng-container *ngFor="let option of options; let i = index">
    <mat-radio-button
      class="radio-btn"
      [attr.data-at-value]="option.value"
      [value]="option.value === currentValue"
      [checked]="option.value === currentValue"
      (click)="emit(option.value)"
    >
      <span>{{ option.viewValue }}</span>
      <ng-container
        *ngIf="
          option.additionalOptionEnabled === true &&
          !!option.additionalOption &&
          option.value === currentValue
        "
      >
        <span
          class="radio-additional-option"
          (click)="onAdditionalOptionSelected($event)"
          gtm="onOpen"
          gtmAction="Notifications Configuration"
          gtmCategory="settings"
          >{{ option.additionalOption }}</span
        >
      </ng-container>
    </mat-radio-button>
  </ng-container>
</mat-radio-group>
